import React, { useEffect, useState } from "react";
import Video from "../../ui/video";
import LayoutHeader from "../../../layouts/layoutHeader";

const HeaderVideo = ({ content }) => {

	const [isMobile, setIsMobile] = useState(true)
	const [isReady, setIsReady] = useState(false)

	useEffect(() => {
		if (window.innerWidth > 768) {
			setIsMobile(false)
			setIsReady(true)
		}
	}, []);

	return (
		<LayoutHeader Sobre>
			<div className=" flex md:gap-8 items-center justify-center text-white h-full container mx-auto md:pt-8">
				<div className=" basis-2/2 md:basis-1/2 flex items-center justify-center z-20">
					<div>
						<h1 className=" text-5xl mb-4">{content.titre}</h1>
						<p className="x-light-violet" dangerouslySetInnerHTML={{ __html: content.description }}></p>
					</div>
				</div>
				<div id="video-napsis" className="hidden md:basis-1/2 md:z-20 md:flex">
					{
						!isMobile ?
							isReady ?
								< Video
									file='napsis'
								/>
								: ''
							: ''
					}
				</div>
			</div>
			<div className="animate-bounce absolute mx-auto bottom-5 left-0 right-0 p-2 z-20 w-10 h-10 ring-1 ring-slate-900/5 dark:ring-slate-200/20 shadow-lg rounded-full flex items-center justify-center"><svg className="w-6 h-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor"><path stroke="#808bef" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path></svg></div>
		</LayoutHeader>
	)
}


export default HeaderVideo
